import React from 'react';
import { FabProductInfo } from './container';

export const FabProductInfoScreen = ({ navigation }: { navigation: any }) => {
    return <FabProductInfo />
}